function randomFromInterval(min, max) {
  return Math.random() * (max - min) + min;
}

// Generate cat whiskers (cartoon style - prominent and symmetrical)
export function generateWhiskers(snoutStartY, snoutWidth, headScale = 1) {
  let whiskers = [];

  // Number of whiskers per side (cartoon cats typically have 3-4)
  let whiskerCount = Math.floor(randomFromInterval(3, 5));

  // Whisker length variation (longer for cartoon style)
  let baseLength = randomFromInterval(40, 75) * headScale;

  for (let i = 0; i < whiskerCount; i++) {
    // Vertical spacing for whiskers
    let verticalOffset = (i - whiskerCount / 2) * 6;

    // Left side whiskers
    let leftStartX = -snoutWidth * randomFromInterval(0.4, 0.6);
    let leftStartY = snoutStartY + verticalOffset;

    // Angle pointing slightly upward and outward
    let leftAngle = randomFromInterval(-0.3, 0.2);
    let leftLength = baseLength * randomFromInterval(0.8, 1.15);

    let leftEndX = leftStartX - leftLength * Math.cos(leftAngle);
    let leftEndY = leftStartY + leftLength * Math.sin(leftAngle);

    whiskers.push({
      start: [leftStartX, leftStartY],
      end: [leftEndX, leftEndY]
    });

    // Right side whiskers (mirrored)
    let rightStartX = snoutWidth * randomFromInterval(0.4, 0.6);
    let rightStartY = snoutStartY + verticalOffset;

    let rightAngle = randomFromInterval(-0.3, 0.2);
    let rightLength = baseLength * randomFromInterval(0.8, 1.15);

    let rightEndX = rightStartX + rightLength * Math.cos(rightAngle);
    let rightEndY = rightStartY + rightLength * Math.sin(rightAngle);

    whiskers.push({
      start: [rightStartX, rightStartY],
      end: [rightEndX, rightEndY]
    });
  }

  return whiskers;
}
